export default __webpack_public_path__ + "static/media/qr2.50877b07.jpeg";